import { Suspense, lazy } from "react";
import PrivateRoute from "./PrivateRoute";
const Employee = lazy(() => import("../modules/employee"));
const EmployeeInformations = lazy(() =>
  import("../modules/employee/employeeInformations/Index")
);
const BasicInformation = lazy(() =>
  import("../modules/employee/employeeInformations/BasicInformation")
);
const Certificates = lazy(() =>
  import("../modules/employee/employeeInformations/Certificates")
);
const WorkBookLate = lazy(() =>
  import("../modules/employee/employeeInformations/WorkBookLate")
);
const FamilyMembers = lazy(() =>
  import("../modules/employee/employeeInformations/FamilyMembers")
);
const Permits = lazy(() =>
  import("../modules/employee/employeeInformations/Permits")
);
const Documents = lazy(() =>
  import("../modules/employee/employeeInformations/Documents")
);
const EmpAttendance = lazy(() =>
  import("../modules/employee/employeeInformations/attendance/Index.jsx")
);
const EmpAbsences = lazy(() =>
  import("../modules/employee/employeeInformations/absences/Index")
);
const EmployeeInformationForm = lazy(() =>
  import("../modules/employee/employeeInformations/EmployeeInformation")
);
const Attendance = lazy(() => import("../modules/attendence"));
const Absences = lazy(() => import("../modules/absences"));
const PersonalUserProfile = lazy(() =>
  import("../modules/admin/user-management/PersonalUserProfile")
);

import PageLoader from "../components/PageLoader";
import { Navigate } from "react-router-dom";
//all employee routes
const EmployeeRoutes = [
  {
    path: "/employee",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute>
          <Employee />
        </PrivateRoute>
      </Suspense>
    ),
  },
  //employee information and it's sub routers
  {
    path: "/employee-information/:id",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute>
          <EmployeeInformations />
        </PrivateRoute>
      </Suspense>
    ),
    //sub routes
    children: [
      {
        path: "/employee-information/:id", // call first components as a basic information when cal routes is employee-information
        element: <Navigate to="basic-information" />,
      },
      {
        path: "basic-information",
        element: (
          <Suspense fallback={<PageLoader />}>
            <PrivateRoute>
              <BasicInformation />
            </PrivateRoute>
          </Suspense>
        ),
      },
      {
        path: "employee-informationform",
        element: (
          <Suspense fallback={<PageLoader />}>
            <PrivateRoute>
              <EmployeeInformationForm />
            </PrivateRoute>
          </Suspense>
        ),
      },
      {
        path: "employee-certificates",
        element: (
          <Suspense fallback={<PageLoader />}>
            <PrivateRoute>
              <Certificates />
            </PrivateRoute>
          </Suspense>
        ),
      },
      {
        path: "employee-work-booklate",
        element: (
          <Suspense fallback={<PageLoader />}>
            <PrivateRoute>
              <WorkBookLate />
            </PrivateRoute>
          </Suspense>
        ),
      },
      {
        path: "employee-family-members",
        element: (
          <Suspense fallback={<PageLoader />}>
            <PrivateRoute>
              <FamilyMembers />
            </PrivateRoute>
          </Suspense>
        ),
      },
      {
        path: "employee-Permits",
        element: (
          <Suspense fallback={<PageLoader />}>
            <PrivateRoute>
              <Permits />
            </PrivateRoute>
          </Suspense>
        ),
      },
      {
        path: "employee-Documents",
        element: (
          <Suspense fallback={<PageLoader />}>
            <PrivateRoute>
              <Documents />
            </PrivateRoute>
          </Suspense>
        ),
      },
      {
        path: "employee-Attendance",
        element: (
          <Suspense fallback={<PageLoader />}>
            <PrivateRoute>
              <EmpAttendance />
            </PrivateRoute>
          </Suspense>
        ),
      },
      {
        path: "employee-Absences",
        element: (
          <Suspense fallback={<PageLoader />}>
            <PrivateRoute>
              <EmpAbsences />
            </PrivateRoute>
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "/attendance",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute>
          <Attendance />
        </PrivateRoute>
      </Suspense>
    ),
  },
  {
    path: "/absences",
    element: (
      <Suspense fallback="loading">
        <PrivateRoute>
          <Absences />
        </PrivateRoute>
      </Suspense>
    ),
  },
  {
    path: "/my-profile",
    element: (
      <Suspense fallback="loading">
        <PrivateRoute>
          <PersonalUserProfile />
        </PrivateRoute>
      </Suspense>
    ),
  },
];
export default EmployeeRoutes;
